import { MdArrowDownward, MdArrowUpward, MdRemove } from 'react-icons/md'
import { Delta } from './marketing-format'

interface DeltaBadgeProps {
    delta: Delta | null
    size?: 'sm' | 'xs'
    /** Texto do tooltip (ex.: "Antes: 120"). */
    title?: string
}

/**
 * Seta e variação contra o período comparado. A COR diz se foi bom ou ruim (custo que
 * sobe é vermelho), a SETA diz para onde o número foi — as duas juntas, para não
 * depender só da cor.
 */
export default function DeltaBadge({ delta, size = 'xs', title }: DeltaBadgeProps) {
    if (!delta) return null

    const toneClass =
        delta.tone === 'good'
            ? 'bg-success/10 text-success'
            : delta.tone === 'bad'
              ? 'bg-error/10 text-error'
              : 'bg-base-200 text-base-content/60'
    const textSize = size === 'sm' ? 'text-xs' : 'text-[11px]'

    let label: string
    if (delta.diff === 0) label = '0%'
    else if (delta.fromZero) label = 'novo'
    else if (delta.pct == null) label = '—'
    else label = `${Math.abs(delta.pct).toLocaleString('pt-BR', { maximumFractionDigits: Math.abs(delta.pct) < 10 ? 1 : 0 })}%`

    const Icon = delta.diff > 0 ? MdArrowUpward : delta.diff < 0 ? MdArrowDownward : MdRemove
    const direction = delta.diff > 0 ? 'Alta' : delta.diff < 0 ? 'Queda' : 'Estável'

    return (
        <span
            className={`inline-flex items-center gap-0.5 rounded-full px-1.5 py-0.5 font-semibold whitespace-nowrap ${toneClass} ${textSize}`}
            title={title}
            aria-label={`${direction} de ${label}${title ? `. ${title}` : ''}`}
        >
            <Icon className="text-[0.95em]" />
            {label}
        </span>
    )
}
